import React, { useState } from "react";
import "./style.scss";
import qs from "qs";
import NoticeIndex from "../NoticeIndex";
import NoPermission from "./../NoPermission";

export default function SchemeList() {
  const [empty, setEmpty] = useState(false);
  const urlQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { appKey } = urlQuery;
  const onHandleTableData = (res) => {
    if (!res) {
      setEmpty(true);
    }
  };
  return (
    <div className="scheme_list">
      {empty ? (
        <NoPermission content="应用未绑定合同，无法查看对接方案" />
      ) : (
        <NoticeIndex appKey={appKey} onHandleTableData={onHandleTableData} />
      )}
    </div>
  );
}
